// Every company-scoped cache in the app is keyed with an 'apc_' (Activation
// Progress Cache — user/company details, Dukakit Payments status, setup
// milestones, dismissed suggestions) or 'bi_' (Business Intelligence) prefix.
// None of them carry a company/branch id in the key itself, so switching
// companies/branches — or a settings change that makes one of them stale —
// must clear them all; otherwise the previous company's cached data (or
// dismissed-suggestion state) keeps showing until each cache's own TTL
// happens to expire (some have none at all, e.g. dismissed-suggestion
// flags, and would otherwise never self-correct).
export default function clearCompanyScopedCache() {
  Object.keys(localStorage)
    .filter((key) => key.startsWith('apc_') || key.startsWith('bi_'))
    .forEach((key) => localStorage.removeItem(key));
}
